/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable @typescript-eslint/ban-types */
import { InputAdornment, TextField } from '@material-ui/core'
import React from 'react'
import { Check as CheckIcon } from '@material-ui/icons'
import clsx from 'clsx'
import { useStyles } from '../Styles'
import { TextFieldProps } from './Type'
import { useJustSubmitted } from '../Hooks/JustSubmitted'

export const FlatsyTextField: React.FC<TextFieldProps> = ({
  type,
  label,
  onChange,
  value,
  inputAdornment,
  error,
  name,
  width,
  multiline,
  ref,
  onBlur,
  isDirty,
  isSubmitSuccessful,
  disabled,
  helperText,
  maxLength,
}) => {
  const style = { width: width || '' }
  const classes = useStyles()
  const isFieldSubmitting = useJustSubmitted({ isDirty, isSubmitSuccessful })

  return (
    <div className={clsx(classes.containerTextField, isFieldSubmitting && 'field-updated')}>
      <TextField
        key={name}
        style={style}
        inputRef={ref}
        name={name}
        variant="outlined"
        multiline={multiline ? true : undefined}
        type={type}
        label={label}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        disabled={disabled}
        helperText={helperText}
        InputProps={{
          endAdornment: (
            <>
              <InputAdornment position="end" className="field-check">
                <CheckIcon />
              </InputAdornment>
              {inputAdornment && <div className={classes.grey}>{inputAdornment}</div>}
            </>
          ),
        }}
        inputProps={{
          ...(maxLength ? { maxLength } : {}),
        }}
        error={!!error?.message}
        rows={multiline ? 4 : ''}
      />
      {!!error?.message && <span className={classes.error}>{error?.message}</span>}
    </div>
  )
}

export default FlatsyTextField
